import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faLocationDot } from "@fortawesome/pro-solid-svg-icons";

import { PillVariants } from "src/design-system/Pill";
import { ModelRegion } from "src/genai/ModelSelector/types";

/** Number of tiles on the relative intelligence/speed scale. */
export const TIER_LEVELS = 5;

/** Base URL the provider/model icons are served from. */
export const PROVIDER_ICON_BASE_URL = "https://app.cp.taktile.com";

export const TAKTILE_HOSTED_TOOLTIP =
  "Hosted by Taktile for additional privacy. Your data stays within AWS infrastructure.";

export const BYOK_TOOLTIP =
  "Routed to your own provider deployment with your keys. Residency follows your configuration.";

type RegionBadge = {
  label: string;
  variant: PillVariants;
  icon: IconProp;
};

// All data-residency regions share one pill style (gray + location icon); only
// the label differs, so "Global" reads as a peer of EU/US/AU rather than a
// differently-colored, differently-iconed outlier.
const REGION_PILL = { variant: "gray", icon: faLocationDot } as const;

export const REGION_BADGES: Record<ModelRegion, RegionBadge> = {
  eu: { label: "EU", ...REGION_PILL },
  us: { label: "US", ...REGION_PILL },
  au: { label: "AU", ...REGION_PILL },
  apac: { label: "APAC", ...REGION_PILL },
  ca: { label: "CA", ...REGION_PILL },
  sa: { label: "SA", ...REGION_PILL },
  global: { label: "Global", ...REGION_PILL },
};
